import React, { useState } from "react";
import OtpInputBox from "../../../../UI/OtpInputBox.js";
import Button from "../../../../UI/Button.js";

const BankAccountNo = ({
  validationMsg,
  clearErrors,
  validation,
  trigger,
  getValues,
  onselectAnswer,
  reff,
  className,
  setAccNum,
  SkippedLeads,
  addPending
}) => {
  const [accNo, setAccNo] = useState("");
  const [error, setError] = useState(false);

  const handlebtnChange = (accNo) => {
    setAccNo(accNo);
    setAccNum(accNo);
  };
  const skipNext = () => {
    // let array = JSON.parse(localStorage.getItem('questionData'));
    // array = array.filter(item => item.question_id !== 87);
    // localStorage.setItem('questionData', JSON.stringify(array));
    SkippedLeads("skipFLPAccountNumber", "account_number");
  };

  const handleNext = async (e) => {
    if (accNo.length != 8) {
      setError(true);
      return;
    } else if (parseInt(accNo) === 0) {
      setError(true);
      return;
    } else {
      setError(false);
      onselectAnswer(e);
    }
  };

  return (
    <>
      <div
        className={`radio-box animated fadeInUp  ${className}`}
        id="slide-15"
        ref={reff}
      >
        <h1 className="title">
          Please provide your Bank Account Number
        </h1>
    
      <div className="question-content mt-0 scale-down-ver-center px-3 pb-lg-3 pb-md-3 pb-sm-2 pb-2">
        <div className="row">
          <div className="col-lg-12 mb-2 col-center">
            <div className="otp-input">
              <OtpInputBox
                length={8}
                onChange={handlebtnChange}
                className={"otp-input-field"}
              />
            </div>
            {error && (
              <span className="error_msg mt-2 err_msg">
                Please enter a valid Bank Account Number
              </span>
            )}
          </div>
          <div className="col-lg-12 mt-2">
            <button
              type="button"
              className="btn-next btncls1"
              id="nextscroll"
              name="accnum"
              onClick={handleNext}
              data-quest-id={87}
            >
              Next
            </button>
          </div>
          <span className="warning-text">
            {
              "(Please confirm your Account Number Code to expedite your claim. If you prefer not to, you can skip this step.)"
            }
          </span>
          <div className="col-lg-12">
          <div className="mb-2 mt-3 text-center">
            <a className="backbtn skip-btn" name="account_number" onClick={skipNext}>
              {"Skip"}
            </a>
          </div>
        </div>
        <div class={`text-center back `}>
                    <Button 
                    className="btn btn-link mt-2 h2" 
                    id="back1" 
                    type="button"
                    buttonText="<< Previous"
                    onClick={()=>addPending("account_number")}
                    />
                    </div>
        </div>
        </div>
      </div>
    </>
  );
};

export default BankAccountNo;